/**
 * The Off tier's smooth fog of war (HD2D-STATUS backlog item 8, "Off preset
 * parity"; integration plan slice 2b): the Off surfaces fade toward the fog
 * colour by the exploration mask sampled bilinearly at the fragment's world
 * position, as Medium's ramp surfaces do, instead of by per-instance colours
 * that split along tile edges. The mask is the floor's W×H RGBA8 texture
 * (`fog.ts`, R explored); the fade and darkening are the per-instance path's
 * numbers (`presentation.fog`).
 */
export const offFogVertexHeader = 'varying vec3 abWorld;';

/** After `project_vertex`: the world position (instanced or not). */
export const offFogVertex = `
vec4 abW=vec4(transformed,1.);
#ifdef USE_INSTANCING
abW=instanceMatrix*abW;
#endif
abWorld=(modelMatrix*abW).xyz;`;

export const offFogFragmentHeader = 'varying vec3 abWorld;uniform sampler2D abMask;uniform vec2 abFloorSize;uniform vec3 abFog;uniform float abFade,abDarken;';

/** After `color_fragment`. */
export const offFogFragment = `
float abSeen=texture2D(abMask,(vec2(abWorld.x,-abWorld.z)+.5)/abFloorSize).r;
diffuseColor.rgb=mix(mix(diffuseColor.rgb,abFog,abFade)*abDarken,diffuseColor.rgb,abSeen);`;
